export const ApiMedia = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (parent, parentId) => {
    const result = await axios.get(`/api/media/${parent}/${parentId}`)
    return result.data
  }

  const find = async (mediaId) => {
    const result = await axios.get(`/api/media/${mediaId}`)
    return result.data
  }

  const upload = async (formdata, params) => {
    axios.setHeader('Content-Type', 'multipart/form-data')
    const result = await axios.$post(`api/media/${params.parent}/${params.parentId}/upload`, formdata)
    console.log(result)
    return result
  }

  return {
    mediaFind: find,
    mediaLoad: load,
    mediaUpload: upload
  }
}
